import HomeIcon from '@material-ui/icons/Home';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import TodayIcon from '@material-ui/icons/Today';
import AssessmentIcon from '@material-ui/icons/Assessment';
import PeopleIcon from '@material-ui/icons/People';
import SettingsIcon from '@material-ui/icons/Settings';
import CallsheetIcon from '@material-ui/icons/Description';
import ScheduleIcon from '@material-ui/icons/Schedule';
import StorageIcon from '@material-ui/icons/Storage';
import TimelineIcon from '@material-ui/icons/Timeline';
import PersonIcon from '@material-ui/icons/Person';
import DateRangeIcon from '@material-ui/icons/DateRange';
import AddToQueueIcon from '@material-ui/icons/AddToQueue';
import StoreIcon from '@material-ui/icons/Store';

import {
  ROUTE_AVAILABILITY,
  ROUTE_BOOKING,
  ROUTE_ECOMM,
  ROUTE_ENTITY_MANAGEMENT,
  ROUTE_HOME,
  ROUTE_LOGOUT,
  ROUTE_USER_PROFILE,
  ROUTE_REPORTING,
  ROUTE_SEARCH,
  ROUTE_SETTINGS,
  ROUTE_CALLSHEET,
  ROUTE_SCHEDULE,
  ROUTE_MY_PROFILE,
  ROUTE_SKU_CARRYOVER,
  ROUTE_CLOSET
} from './constants';
import NotFound from '../components/NotFound';
import AvailabilityView from '../views/AvailabilityView';
import ReportingView from '../views/ReportingView';
import ScheduleView from '../views/ScheduleView';
import EmployeeProfileView from '../views/EmployeeProfileView';
import MyProfileView from '../views/MyProfileView';
import SearchView from '../views/SearchView';
import BookingView from '../views/BookingView';
import EcommView from '../views/EcommView';
import LogoutView from '../views/LogoutView';
import SettingsView from '../views/SettingsView';
import CallsheetView from '../views/CallsheetView';
import DashboardView from '../views/DashboardView';
import EntityManagementView from '../views/EntityManagementView';
import SkuCarryoverView from '../views/SkuCarryoverView';
import ClosetView from '../views/ClosetView';

import i18n from '../i18n';

export const BookingRoute = {
  path: ROUTE_BOOKING,
  exact: true,
  name: 'Booking',
  icon: TodayIcon,
  component: BookingView,
  scopes: ['bookings:read']
};

export const EcommRoute = {
  path: ROUTE_ECOMM,
  exact: true,
  name: 'Ecomm',
  icon: AssessmentIcon,
  component: EcommView,
  scopes: ['activities:read'],
};

export const ReportingRoute = {
  path: ROUTE_REPORTING,
  exact: true,
  name: i18n.t('reporting:reporting'),
  icon: TimelineIcon,
  component: ReportingView,
  scopes: ['reporting:read'],
  featureFlag: 'isUiSstudioReportingViewEnabled',
}

export const ScheduleRoute = {
  path: ROUTE_SCHEDULE,
  exact: true,
  name: i18n.t('schedule'),
  icon: ScheduleIcon,
  component: ScheduleView,
  scopes: ['bookings:read']
};

export const DashboardRoute = {
  path: ROUTE_HOME,
  exact: true,
  name: i18n.t('dashboard'),
  icon: HomeIcon,
  component: DashboardView,
  scopes: ['dashboard:read']
};

export const SearchRoute = {
  path: ROUTE_SEARCH,
  exact: true,
  name: i18n.t('employees'),
  icon: PeopleIcon,
  component: SearchView,
  //  requires at least one of the scopes to be true to view the search route
  scopes: ['employees:read', 'studio-models:read'] 
};

export const EntityManagementRoute = {
  path: ROUTE_ENTITY_MANAGEMENT,
  exact: true,
  icon: StorageIcon,
  name: i18n.t('entityManagement'),
  component: EntityManagementView,
  scopes: ['entities:read']
};

export const SettingRoute = {
  path: ROUTE_SETTINGS,
  exact: true,
  icon: SettingsIcon,
  name: i18n.t('settings'),
  component: SettingsView
};

export const UserProfileRoute = {
  path: ROUTE_USER_PROFILE,
  exact: true,
  icon: PersonIcon,
  name: i18n.t('userProfile'),
  component: EmployeeProfileView
};

export const MyProfileRoute = {
  path: ROUTE_MY_PROFILE,
  exact: true,
  icon: PersonIcon,
  name: i18n.t('myProfile'),
  component: MyProfileView,
  scopes: ['my-profile:read']
};

export const AvailabilityRoute = {
  path: ROUTE_AVAILABILITY,
  exact: true,
  icon: DateRangeIcon,
  name: i18n.t('availability'),
  component: AvailabilityView,
  scopes: ['employees:read', 'studio-models:read'],
}

export const LogoutRoute = {
  path: ROUTE_LOGOUT,
  exact: true,
  icon: ExitToAppIcon,
  name: i18n.t('logout'),
  component: LogoutView,
  public: true
};

export const CallsheetRoute = {
  path: ROUTE_CALLSHEET,
  exact: true,
  icon: CallsheetIcon,
  name: i18n.t('callsheet'),
  component: CallsheetView,
  scopes: ['callsheets:read'],
};

export const NotFoundFallback = {
  component: NotFound,
  visible: false
};

export const SkuCarryoverRoute = {
  path: ROUTE_SKU_CARRYOVER,
  exact: true,
  name: i18n.t('Sku Carryover'),
  icon: AddToQueueIcon,
  component: SkuCarryoverView,
  scopes: ['carryover:write'],
  featureFlag: 'isCarryoverFeatureEnabled',
};

export const ClosetRoute = {
  path: ROUTE_CLOSET,
  exact: true,
  name: i18n.t('Closet'),
  icon: StoreIcon,
  component: ClosetView,
  featureFlag: 'isClosetEnabled',
  scopes: ['closet:read'] 
};

export default [
  AvailabilityRoute,
  BookingRoute,
  EcommRoute,
  EntityManagementRoute,
  LogoutRoute,
  ScheduleRoute,
  DashboardRoute,
  SearchRoute,
  UserProfileRoute,
  MyProfileRoute,
  SettingRoute,
  CallsheetRoute,
  ReportingRoute,
  SkuCarryoverRoute,
  ClosetRoute,
  NotFoundFallback // NotFoundFallback must always be the last item
];